<template>
  <div>
    <div class="record"  v-show="switchTab">
      <div class="cross">
          <div>支付明细</div>
      </div>
      <table border="1" align="center" cellpadding="10" rules="all" cellspacing="5" class="table">
          <thead>
            <tr>
              <th>支付方式</th>
              <th>支付金额(元)</th>
              <th>支付时间</th>
              <th v-if="type=='3'">操作</th>
            </tr>
          </thead>
          <tbody v-for="item in StoreLists.list" :key="item.add_time">
            <tr>
              <td>{{item.channel_type| formatVar('payChannel')}}</td>
              <td>{{item.total_fee/100}} <span v-if="item.refund_fee<0" @click="detailTabSwitch(item)">({{item.refund_fee/100}})</span></td>
              <td>{{item.add_time| formatTimestamp(1)}}</td>
              <td v-if="type=='3'">
                <span class="text-link " @click="checkDetail(item)" v-if="Math.abs(item.refund_fee)!=item.total_fee">退款</span>
                <p v-else>已退全额</p>
              </td>
            </tr>
          </tbody>
      </table>
        <el-pagination
          v-if="StoreLists.list.length>10" 
          background layout="prev, pager, next" class="mt-4 mb-4 text-center"
          :page-size="10" :total="StoreLists.count" :current-page=FormData.page 
          @current-change="v => {FormData.page=v;TraGroupGetStoreLists(FormData)}"
        />
    </div>
    <div class="record"  v-if="!switchTab">
      <div class="cross">
          <i class="el-icon-back" @click="switchTab=true">返回明细</i>
          <div>退款记录</div>
      </div>
      <table border="1" align="center" cellpadding="10" cellspacing="5" class="table">
          <thead>
            <tr>
              <th>支付方式</th>
              <th>退款金额(元)</th>
              <th>退款时间</th>
            </tr>
          </thead>
          <tbody v-for="item in RefundLists.list" :key="item.add_time">
            <tr>
              <td>{{item.channel_type| formatVar('payChannel')}}</td>
              <td>{{item.refund_fee/100}}</td>
              <td>{{item.add_time| formatTimestamp(1)}}</td>
            </tr>
          </tbody>
      </table>
        <el-pagination 
          v-if="RefundLists.list.length>5"
          background layout="prev, pager, next" class="mt-4 mb-4 text-center"
          :page-size="10" :total="RefundLists.count" :current-page=refundFormData.page 
          @current-change="v => {refundFormData.page=v;TraGroupGetRefundLists(refundFormData)}"
        />
    </div>
  </div>
</template>
<script>
 export default 
 {
    name: "Record",
    props:{
        OrderDetail:{
            type:Object,
            default: {}
        },
        type:{}
    },
    data() {
        return {
          switchTab:true,
          //支付列表
          StoreLists:{
            list:[]
          },
          FormData:{
            page:1,
            oid:this.OrderDetail.oid,
            num:10,
          },
          //退款列表
          refundFormData:{
            page:1,
            num:10,
          },
          RefundLists:{
            list:[]
          },
        }  
    },
    mounted() {
        this.TraGroupGetStoreLists(this.FormData);
    },
    methods: {
      //支付明细
      async TraGroupGetStoreLists(data){
            let resData = await this.$axios.post('/pc/Common/OrderTradeList',data);
            if(resData.code=="00000"){
              this.StoreLists=resData.data;
            }
      },
      //detailTab切换
      detailTabSwitch(data){
        this.refundFormData.tid= data.tid;
        this.switchTab=!this.switchTab;
        this.TraGroupGetRefundLists(this.refundFormData);
      },
      //点击退款
      checkDetail(item) {
        this.showDetail=true;
        this.$emit('close',item);
      },
      //退款明细
      async TraGroupGetRefundLists(data){
            let resData = await this.$axios.post('/pc/Common/OrderRefundList',data);
            if(resData.code=="00000"){
              this.RefundLists=resData.data;
            }
      },
    },
  }
</script>
<style scoped>
.cross{
    display: flex;
    justify-content: right;
    overflow: hidden;
    width: 80%;
    margin: 0 auto;
    border-bottom: 1px #eee solid;
    padding: 12px 10%;
    font-weight: bold;
    letter-spacing: 1px;
    font-size: 16px;
}
.cross div{
    margin: 0 auto;
}
.record{
  width: 100%;
  background-color: #fff;
  overflow: hidden;
}
.table{
  width: 94%;
  margin: 20px auto;
}
.table th,.table td{
  text-align: center;
  padding: 8px 0;
  border-color: rgb(235, 238, 245);
  color:#666;
}
.table th{
  color: #333;
  background: rgb(250, 250, 250);
}
.table td span{
  color: var(--smtc-color-primary);
  cursor: pointer;
}
.el-icon-back{
  position: absolute;
  top: 12px;
  left: 10px;
  background-color: #fff;
  color: #17c967;
  padding: 6px 10px;
  border-radius: 15px;
  font-size: 12px;
  cursor: pointer;
}
</style>